<template>

    <div v-if="isAPartner">

        <section class="partner__container">

            <nav class="partner__nav">

                <img class="partner__nav-logo" src="/img/logo/fox/blue-head-white.svg">

                <span v-if="$mq === 'lg'" class="partner__nav-title">Cleanfox</span>

            </nav>


            <header class="partner__head-container">

                <img class="partner__title-img" src="/img/partner/shine-white-left.svg">

                <h1 class="partner__title-text">{{ $tc('partner_title', 0, {'partner_name': infos.name}) }}</h1>

                <img class="partner__title-img" src="/img/partner/shine-white-right.svg">

            </header>

            <p class="partner__subtitle">{{ $tc('partner_subtitle', 0, {partner_name: infos.name}) }}</p>


            <article class="partner__article partner__article-1">

                <img :src="infos.img" class="partner__article-1__img">

                <h2 class="partner__article__title partner__article-1__title">{{ infos.title }}</h2>

                <p class="partner__article__subtitle">{{ infos.text }}</p>

                <div class="partner__article-1__media-container">

                    <template v-for="(value, key)  in infos.medias">

                        <a :href="value" class="partner__article-1__media-btn" target="_blank">

                            <img :src="mediaImg(key)" class="partner__article-1__media-img img-noselect">

                        </a>

                    </template>

                </div>

            </article>

            <article class="partner__article partner__article-2">

                <h2 class="partner__article__title">{{ $t('partner_trees_title') }}</h2>

                <div class="partner__article-2__bloc-container">

                    <div class="partner__article-2__bloc">

                        <h3 v-if="sqmByPartner > -1" class="partner__article-2__number partner__article-2__number-green">{{ sqmByPartner }}</h3>
                        <lottie-loader v-else :size="56" class="partner__article-2__number"></lottie-loader>


                        <p class="partner__article-2__text">
                            {{ $t('partner_trees_planted_partner_1') }}
                            <span class="partner__article-2__text-green">{{ infos.name }}</span>
                            {{ $t('partner_trees_planted_partner_2') }}
                        </p>

                    </div>

                    <div class="partner__article-2__dashline"></div>

                    <div class="partner__article-2__bloc">

                        <h3 v-if="sqmByAll > -1" class="partner__article-2__number partner__article-2__number-blue">{{ sqmByAll }}</h3>
                        <lottie-loader v-else :size="56" class="partner__article-2__number"></lottie-loader>

                        <p class="partner__article-2__text">
                            {{ $t('partner_trees_planted_cleanfox_1') }}
                            <span class="partner__article-2__text-blue">{{ $t('partner_trees_planted_cleanfox_2') }}</span>
                            {{ $t('partner_trees_planted_cleanfox_3') }}
                        </p>

                    </div>

                </div>

            </article>

            <article class="partner__article partner__article-3">

                <img class="partner__article-3__foxy" src="/img/foxy/middle-smile.png">

                <h2 class="partner__article__title">{{ $t('partner_participation_title') }}</h2>

                <p class="partner__article__subtitle">{{ $tc('partner_participation_description', 0, {'partner_name': infos.name}) }}</p>

                <button class="btn btn-big partner__article-3__btn-code" @click="copyCode">

                    <p class="partner__article-3__code-text">{{ infos.code }}</p>

                    <span :class="{ 'partner__article-3__clicked': clicked }" class="partner__article-3__code-link">{{ computedClicked }}</span>

                </button>

                <button v-if="isNotConnected" class="btn btn-big btn-blue partner__article-3__btn-subscribe" @click="goLanding">{{
                        $t('partner_cta_inscription')
                    }}
                </button>

                <div class="partner__article-3__bottom-container pointer" @click="download">

                    <img class="partner__article-3__bottom-img" src="/img/logo/fox/blue-head-white.svg">

                    <p class="partner__article-3__bottom-text">{{ $t('partner_cta_stores') }}</p>

                </div>

            </article>

            <article class="partner__article">

                <h2 class="partner__article__title">{{ $t('partner_about_weforest_title') }}</h2>

                <p class="partner__article__subtitle">{{ $t('partner_about_weforest_description') }}</p>

                <a class="partner__article__link-container pointer">

                    <span class="partner__article__link-text">{{ $t('partner_about_weforest_cta') }}</span>

                    <img class="partner__article__link-arrow" src="/img/icons/arrow-right-blue.svg">
                </a>

            </article>


        </section>

        <footer-landing></footer-landing>

    </div>

</template>

<script>

import Api from '@/api'

import Storage from '@/helpers/storage'

import I18n from '@/modules/i18n'
import Partners from '@/modules/partners'
import Tag from '@/modules/tag'
import UserAgent from '@/modules/userAgent'
import UserFlow from '@/modules/userFlow'

import FooterLanding from '@/components/FooterLanding'
import LottieLoader from '@/components/lottie/LottieLoader'

export default {

    name: 'partner',

    components: {FooterLanding, LottieLoader},

    computed: {

        computedClicked: function () {

            return this.clicked ? this.$t('we_forest_code_copied') : this.$t('partner_cta_copy')

        },

        isAPartner: function () {

            return this.infos && Object.keys(this.infos).length > 0

        },

        isNotConnected: function () {

            return !Storage.getItem('token')

        }

    },

    data() {
        return {
            title: '',
            text: '',
            infos: {},
            clicked: false,
            sqmByPartner: -1,
            sqmByAll: -1

        }
    },

    created() {

        const name = this.$route.params.name

        Partners.getPartner(name)
            .then(result => {

                this.infos = result

                if (!this.isAPartner) {

                    this.exit()

                }

                UserFlow.setPage(this, `partner_${name}`)

                Api.sponsorship.getAll()
                    .then(data => {
                        this.sqmByAll = Math.round(data.sqm)
                    })
                    .catch(() => {
                    })

                Api.sponsorship.getByPartner(name)
                    .then(data => {
                        this.sqmByPartner = Math.round(data.sqm)
                    })
                    .catch(error => {
                    })

            })
            .catch(() => {
            })

    },

    methods: {

        exit() {

            if (Storage.getItem('token')) {

                this.$router.push({path: '/newsletters'})

            } else {

                this.$router.push({path: '/'})

            }

        },

        back() {

            Tag.clickAmplitude(this, 'back')

            this.$router.push({path: '/'})
        },

        clean() {

            Tag.clickAmplitude(this, `partner_${this.$route.params.name}_clean`)

            this.$router.push({path: '/'})

        },

        contact() {

            Tag.clickAmplitude(this, `partner_${this.$route.params.name}_contact`)
            window.open('mailto:support@cleanfox.io', '_blank', 'rel="noopener,noreferrer,nofollow"')

        },

        mediaImg(media) {

            return `/img/icons/${media}-white.svg`

        },

        goLanding() {


            this.$router.push({path: '/'})

        },

        copyCode() {

            Storage.setItem('partnerCode', this.infos.code)

            // createTextArea
            const textArea = document.createElement('textArea')
            textArea.value = this.infos.code
            textArea.setAttribute('readonly', 'readonly')
            document.body.appendChild(textArea)

            // selectText
            if (UserAgent.is.ios()) {
                const range = document.createRange()
                range.selectNodeContents(textArea)
                const selection = window.getSelection()
                selection.removeAllRanges()
                selection.addRange(range)
                textArea.setSelectionRange(0, 999999)
            } else {
                textArea.select()
            }

            // copyToClipboard
            document.execCommand('copy')
            document.body.removeChild(textArea)

            this.clicked = true
        },

        download() {

            if (UserAgent.is.ios()) {

                window.open('https://apps.apple.com/app/id1136298377?mt=8', '_blank', 'rel="noopener,noreferrer,nofollow"')

            } else {

                window.open('https://play.google.com/store/apps/details?id=io.cleanfox.android&hl=' + I18n.get(this), '_blank', 'rel="noopener,noreferrer,nofollow"')
            }

        }

    }
}
</script>

<style lang="scss" scoped>

.partner {

    &__container {
        padding: 0 16px 80px;
        background-color: $blue;
        display: flex;
        flex-direction: column;
        color: $white;
        background-image: url('/img/background/partner-mobile.svg');
        background-repeat: no-repeat;
        background-position: bottom;
        background-size: cover;
        align-items: center;
        @media screen and (min-width: $above-tablet-length) {
            padding: 0 0 80px;
        }
    }

    &__nav {
        height: 48px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: $blue;
        width: 100%;
        @media screen and (min-width: $above-tablet-length) {
            height: 64px;
        }
    }

    &__nav-logo {
        height: 40px;
        object-fit: contain;
        margin-left: 2px;
    }

    &__nav-title {
        font-size: 22px;
        font-weight: bold;
    }

    &__head-container {
        margin-top: 32px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
    }

    &__title-img {
        height: 40px;
        object-fit: contain;
    }

    &__title-text {
        margin: 0 4px;
        text-shadow: 0 0 25px rgba(0, 0, 0, 0.1);
        font-size: 28px;
        font-weight: bold;
        @media screen and (min-width: $above-tablet-length) {
            margin: 0 16px;
            font-size: 40px;
            line-height: 1.4;
        }
    }

    &__subtitle {
        margin-top: 16px;
        text-shadow: 0 0 25px rgba(0, 0, 0, 0.1);
        font-size: 17px;
        font-weight: 500;
        line-height: 1.29;
        max-width: 976px;
        @media screen and (min-width: $above-tablet-length) {
            font-size: 22px;
            line-height: 1.27;
            letter-spacing: -0.2px;
            margin-top: 24px;
        }
    }

    &__article {
        background-color: $white;
        padding: 24px;
        border-radius: 12px;
        margin-top: 16px;
        position: relative;
        color: $midnight;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 100%;
        max-width: 480px;
        @media screen and (min-width: $above-tablet-length) {
            margin-top: 24px;
            padding: 32px;
        }

        &__title {
            font-size: 22px;
            font-weight: bold;
            line-height: 1.09;
            margin: 0;
        }

        &__subtitle {
            font-size: 17px;
            line-height: 1.29;
            margin-top: 8px;
        }

        &__link-container {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            height: 21px;
            color: $aquamarine;
            margin-top: 16px;
        }

        &__link-text {
            font-size: 16px;
            font-weight: bold;
            line-height: 1.31;
        }

        &__link-arrow {
            width: 16px;
            object-fit: contain;
            margin-left: 4px;
        }
    }

    &__article-1 {

        margin-top: 80px;

        &__img {
            width: 88px;
            height: 88px;
            border: solid 4px $white;
            position: absolute;
            top: -44px;
            border-radius: 100%;
        }

        &__title {
            margin-top: 36px;
        }

        &__media-container {
            margin-top: 16px;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
        }

        &__media-btn {
            margin: 0 6px;
            height: 24px;
            width: 24px;
            cursor: pointer;
            background-color: $midnight;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 100%;
        }

        &__media-img {
            width: 12px;
            object-fit: contain;
        }

    }

    &__article-2 {
        padding: 32px;
        @media screen and (min-width: $above-tablet-length) {
            padding: 32px 0 0;
        }

        &__title {
            font-size: 22px;
            font-weight: bold;
            line-height: 1;
        }

        &__bloc-container {
            display: flex;
            flex-direction: column;
            @media screen and (min-width: $above-tablet-length) {
                flex-direction: row;
                width: 100%;
                justify-content: space-evenly;
            }
        }

        &__bloc {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            @media screen and (min-width: $above-tablet-length) {
                margin-bottom: 32px;
                width: 100%;
                max-width: 176px;
            }
        }

        &__dashline {
            width: 100%;
            height: 1px;
            background-color: $silver;
            margin-top: 32px;
            @media screen and (min-width: $above-tablet-length) {
                width: 2px;
                height: auto;
                margin: 24px 0 0;
            }
        }

        &__number {
            font-family: Roboto;
            font-size: 48px;
            font-weight: bold;
            margin: 32px 0 0;
        }

        &__number-green {
            color: $forest;
        }

        &__number-blue {
            color: $aquamarine;
        }

        &__text {
            font-size: 12px;
            font-weight: 600;
            margin-top: 24px;
        }

        &__text-green {
            color: $forest;
        }

        &__text-blue {
            color: $aquamarine;
        }
    }

    &__article-3 {
        margin-top: 115px;
        padding: 24px;
        @media screen and (min-width: $above-tablet-length) {
            margin-top: 128px;
            padding: 32px;
        }

        &__foxy {
            height: 118px;
            top: -107px;
            position: absolute;
        }

        &__title {
            font-size: 22px;
            font-weight: bold;
            line-height: 1.27;
            margin: 0;
        }

        &__subtitle {
            margin-top: 8px;
            font-size: 17px;
            line-height: 1.29;
        }

        &__btn-code {
            border: dashed 2px $silver;
            margin-top: 24px;
            display: flex;
            flex-direction: column;
            min-width: 231px;
            width: auto;
        }

        &__code-text {
            font-size: 22px;
            font-weight: bold;
            line-height: 1.27;
            letter-spacing: 1.1px;
            color: $midnight;
        }

        &__code-link {
            font-size: 13px;
            font-weight: 600;
            line-height: 1.38;
            color: $aquamarine;
        }

        &__clicked {
            color: $green;
        }

        &__btn-subscribe {
            margin-top: 16px;
            max-width: 220px;
        }

        &__bottom-container {
            display: flex;
            flex-direction: row;
            margin-top: 16px;
            align-items: center;
            justify-content: center;
        }

        &__bottom-img {
            height: 24px;
            object-fit: contain;
            margin-right: 8px;
        }

        &__bottom-text {
            font-size: 12px;
            line-height: 1.33;
        }
    }
}


</style>
